import { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  Table,
  Spin,
  Tooltip,
  
  DatePicker,
  Input,
  message,
} from "antd";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";

import bus from "../../asserts/umbuslogo.png";

import moment from "moment";
import { MdLocationOn, MdDateRange, MdOutlineAccessTime, MdError } from "react-icons/md";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import { GetRefundRequestDetails, handleGetOtp, handleGetUserNumber, handleOTPVerify } from "../../Api/Payments/Payments";
import ModalPopup from "../Common/Modal/Modal";
import { ConfigProvider, Select,Space  } from "antd";
import {
  ErrorMessage,
  Field,
  Formik,
  Form

} from "formik";
import { IoMdArrowDropdown } from "react-icons/io";
import {handleRefundRequestNormal,handleRefundRequestStatus} from "../../Api/Payments/Payments"
import { RiRefund2Line } from "react-icons/ri";
import { MdVerified } from "react-icons/md";
import {handleGetUser} from "../../Api/Payments/Payments";
import * as Yup from 'yup';
import { useFormikContext } from "formik";
import { toast } from "react-toastify";
const{Option}=Select;


export default function RefundRequestTable({ activePage, setActivePage, deviceid }) {
  const [spinning, setSpinning] = useState(false);
  const [updatedata, SetUpdateData] = useState();
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [isRowExpanded, setIsRowExpanded] = useState(false);

  
  const [sortedData, setSortedData] = useState([]);
  const [sortOrderDate, setSortOrderDate] = useState(null);
  const [sortOrderFare, setSortOrderFare] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const[refund,setRefund]=useState();
  const [mobile,setMobile]=useState();
  const [email,setEmail]=useState();
  const[payId,setPayId]=useState();
  const[ticketNo,setTicketNo]=useState();
  const [currentpage,setCurrentPage]=useState(1);
 const[verifyValues,setVerifyValues]=useState();
  const[paymentType,setPaymentType]=useState("Normal")
  const [submitmodalIsOpen, setSubmitModalIsOpen] = useState(false);
  const[valuesForm,setValues]=useState();
  const[isTimerRunning,setTimerRunning]=useState(false);
  const[timeLeft,setTimeLeft]=useState(300);
  const[isVerify,setIsVerify]=useState();
  const[verifyStatus,setVerifyStatus]=useState(false);
  const[isTimer,setTimer]=useState(false);
  const[otp,setOtp]=useState();
  const [selectedUser, setSelectedUser] = useState(null);
const [isDisabled, setIsDisabled] = useState(false);
const[userMessage,setMessage]=useState();
// const {setFieldValue}=useFormikContext();
  const date1 = new Date('10 June 2025');
  const [date2,setDate2]=useState();
  const date3=new Date(date2);
  console.log(date3,"DATE")
  const getrefundrequest =
    useSelector((state) => state.crm.refund_request) || [];
  console.log(getrefundrequest, "cancellation details dashboard");
  const userDetail =
    useSelector((state) => state.crm.user_detail) || [];
  console.log(userDetail, "user details dashboard");

  const userNumber =
    useSelector((state) => state.crm.user_number);
  console.log(userNumber, "userNumber dashboard");

const verifyOtp=sessionStorage.getItem("refundOtp");


const isButtonDisabled = !isTimerRunning || !selectedUser;
  const closeSubmitModal = () => {
    dispatch({type:"RESETNUMBER"});
    setSubmitModalIsOpen(false);
    setIsModalOpen(false)
    setIsDisabled(false)
    setTimerRunning(false)
    setVerifyStatus(false)
    setTimer(false)
    setTimeLeft()
    setIsVerify()
    setSelectedUser();
    setMessage();
     setOtp();

  };
  const closeModal = () => {
  setIsModalOpen(false)
    setIsVerify();
    setIsDisabled(false)
    setTimer(false);
    setTimerRunning(false);
    setTimeLeft();
    setSelectedUser();
    setVerifyStatus(false);
     setOtp("");
     setMessage();
     dispatch({type:"RESETNUMBER"});
  };

 
const handleSubmitClick = () => {
  
    setSpinning(true);
    if(deviceid === 0){
      GetRefundRequestDetails(dispatch,setSpinning,deviceid)
    } else if (deviceid === 1) {
      console.log("BookingTable deviceId:", deviceid);
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    } else if (deviceid === 2) {
      console.log("BookingTable deviceId:", deviceid);
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    }
   
   setIsModalOpen(false);
   setSubmitModalIsOpen(false);
   dispatch({type:"RESETNUMBER"});
  };

  




const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")} : ${String(secs).padStart(2, "0")}`;
  };

  // Timer logic
  useEffect(() => {
    let timer;
    if (timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
        setTimerRunning(true)
      }, 1000);
    } else if (timeLeft === 0&& isDisabled) {
     
      setIsDisabled(false)
      // setTimer(false);
      // setTimeLeft(false);
    }
    return () => clearInterval(timer);
  }, [timeLeft,isDisabled]);


  const handleVerify=async(values)=>{
    
    setTimer(false);
  setTimerRunning(false);
  setTimeLeft()
    setIsDisabled(false)
    console.log(values,"valueeeeeees")
    if(verifyOtp===values.otp){ 
    try{
      setIsVerify( 
   <span className="flex text-gray-500 text-[1.1vw] font-medium items-center gap-x-2"><MdVerified className="text-green-500 text-[1vw] font-medium"/>  OTP Verified</span>)
      setVerifyStatus(true);
      // toast.success("Verified Successfully")
    }catch{
      
      console.error("Submission error:OTP Miss Matched");
    }}
    else {
      setIsVerify
    (<span className="flex items-center gap-x-2 text-gray-500 text-[1.1vw] font-medium"><MdError className="text-red-600 text-[1.1vw] font-medium"/>  OTP Missmatched</span>)
  
      setVerifyStatus(false);
      // toast.error("OTP Missmatched")
    }
   
}
  
  const handlePrevious=()=>{
    
    setCurrentPage(1);
    setIsVerify();
    setIsDisabled(false)
    setTimer(false);
    setTimerRunning(false);
    setTimeLeft();
    setSelectedUser();
    setVerifyStatus(false);
     setOtp("");
     setMessage();
     dispatch({type:"RESETNUMBER"});
  }
 



  const handleUserChange = async (user_id)=> {
    
    setSelectedUser(user_id);
    setTimeLeft(300);
     // Clear previous mobile number while fetching

    try {
      const response = await handleGetUserNumber(dispatch,user_id) // Replace with your API endpoint
      
    //  setMobileNumber(userNumber)
      console.log(response,"mobileNumber") // Assuming API returns mobileNumber
    } catch (error) {
      console.error('Error fetching mobile number:', error);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Ensure only 6-digit numeric input
    if (/^\d{0,7}$/.test(value)) {
      setOtp(value);
      console.log(otp,"OOOOOO");
      
      
    }
  };


  const handleMouseOver = (event) => {
    event.target.removeAttribute("title");
  };
  const GetStatusOpt = () => {
    if (deviceid == "0") {
      return [
        { label: "Normal", payment_type: "Normal" },
        { label: "Instant", payment_type: "Instant" },
        
      ];
    } 
  };

  const handleSubmitCheck=()=>{
    handleVerify(verifyValues)
    
    handleSubmit(valuesForm);
   
    setSubmitModalIsOpen(true);
    
  }

    const handleSubmit = async (values) => {
      
      console.log("Form values:", values);
  
      try {
        console.log(" values Payid:", values.pay_id);
        console.log(" values Amount:", values.amount);
        if(payId&&values.amount){
const response = await handleRefundRequestNormal(values);      
        console.log(" Response Normal:", response);
        }
        

       
        //  console.log(" Response Status:", status);
        
        
      } catch (err) {
        console.error("Submission error:", err);
        
      } 
    };

    const handleOTPSubmit=async(values)=>{
      setTimeLeft(300);
      setIsDisabled(true);
      console.log("Form values:", values);
      try {
        console.log(" values Mobile:", values.userNumber);
        
        // console.log(" values OTP:", values.otp);
        const otpSent = await handleGetOtp(values);
        console.log(otpSent,"OTP RESPONSE");
        
        
        
      } catch (err) {
        console.error("Submission error:", err);
        
      } 
  
    }
    

 const options = GetStatusOpt();
  const handleFareSort = () => {
    let sorted = [...getrefundrequest];
    if (sortOrderFare === "ascend") {
      sorted.sort((a, b) => b.total_fare - a.total_fare);
      setSortOrderFare("descend");
    } else if (sortOrderFare === "descend") {
      sorted = [...getrefundrequest]; // Reset to original order
      setSortOrderFare(null);
    } else {
      sorted.sort((a, b) => a.total_fare - b.total_fare);
      setSortOrderFare("ascend");
    }

    console.log(getrefundrequest, "sort details");
    setSortedData(sorted);
  };

  const handleDateSort = () => {
    let sorted = [...getrefundrequest];
    if (sortOrderDate === "ascend") {
      sorted.sort(
        (a, b) =>
          new Date(b.cancel_date_time.slice(0, 10)) -
          new Date(a.cancel_date_time.slice(0, 10))
      );
      setSortOrderDate("descend");
    } else if (sortOrderDate === "descend") {
      sorted = [...getrefundrequest]; // Reset to original order
      setSortOrderDate(null);
    } else {
      sorted.sort(
        (a, b) =>
          new Date(a.cancel_date_time.slice(0, 10)) -
          new Date(b.cancel_date_time.slice(0, 10))
      );
      setSortOrderDate("ascend");
    }

    console.log(getrefundrequest, "sort details");
    setSortedData(sorted);
  };

  
  const handleRowClick = (record) => {
    console.log(record, "record");
    SetUpdateData(record.ticket_no);
    const newExpandedKey = record.key === expandedRowKey ? null : record.key;
    setExpandedRowKey(newExpandedKey);
    console.log(expandedRowKey, "record record");
    setIsRowExpanded(newExpandedKey !== null);
  };
  const dispatch = useDispatch();
  

  useEffect(() => {
    // Function to prevent zoom on touch events
    const preventZoom = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // Function to prevent double tap zoom
    const preventDoubleTapZoom = (e) => {
      e.preventDefault();
    };

    // Add event listeners for touchstart and double tap
    document.addEventListener("touchstart", preventZoom, { passive: false });
    document.addEventListener("dblclick", preventDoubleTapZoom, {
      passive: false,
    });

    // Add event listener for wheel event to prevent zoom on Ctrl + scroll
    const handleWheel = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });

    // Add event listeners for gesture events on Safari
    const preventGestureZoom = (e) => {
      e.preventDefault();
    };
    document.addEventListener("gesturestart", preventGestureZoom);
    document.addEventListener("gesturechange", preventGestureZoom);
    document.addEventListener("gestureend", preventGestureZoom);

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("touchstart", preventZoom);
      document.removeEventListener("dblclick", preventDoubleTapZoom);
      window.removeEventListener("wheel", handleWheel);
      document.removeEventListener("gesturestart", preventGestureZoom);
      document.removeEventListener("gesturechange", preventGestureZoom);
      document.removeEventListener("gestureend", preventGestureZoom);
    };
  }, []);
  useEffect(() => {
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.getElementsByTagName("head")[0].appendChild(metaTag);

    // Disable pinch-to-zoom
    const preventZoom = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };

    document.addEventListener("wheel", preventZoom, { passive: false });

    return () => {
      document.removeEventListener("wheel", preventZoom);
    };
  }, []);
 

  const itemsPerPage = 10; // Number of items to display per page
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    console.log(activePage, "active page");
    console.log(itemsPerPage, "page items");
    setIsRowExpanded(false);
    // SetUpdateData(null);
    setExpandedRowKey(null);
  };
  // Calculate pagination slice based on activePage
  const indexOfLastItem = activePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  

  const currentItems =
    Array.isArray(sortedData) && sortedData.length > 0
      ? sortedData.slice(indexOfFirstItem, indexOfLastItem)
      : Array.isArray(getrefundrequest)
      ? getrefundrequest.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  console.log(currentItems, "currentItems");
  const { RangePicker } = DatePicker;

  // date picker
  const changeDatePickerPlaceholder = () => {
    const inputDiv = document.querySelector(".ant-picker-input");
    if (inputDiv) {
      const inputElement = inputDiv.querySelector("input");
      if (inputElement) {
        inputElement.placeholder = "Start Date";
      }
    }
  };
  changeDatePickerPlaceholder();

  const changeDatePickerPlaceholder2 = () => {
    const inputDiv = document.querySelector(".ant-picker");
    if (inputDiv) {
      const children = inputDiv.querySelectorAll("div");
      if (children.length > 2) {
        const thirdChild = children[2];
        const inputElement = thirdChild.querySelector("input");
        if (inputElement) {
          inputElement.placeholder = "End Date";
        }
      }
    }
  };
  changeDatePickerPlaceholder2();

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const formatTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(":");
    const date = new Date();
    date.setHours(hours, minutes);

    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return date.toLocaleTimeString("en-US", options);
  };

  const columns = [
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          S.No
        </div>
      ),
      width: "2vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + index + 1;
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {serialNumber}
          </div>
        );
      },
    },

    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Ticket Number
        </div>
      ),
      width: "7vw",
      render: (row, rowdta, index) => {
        return (
          <div className="ml-[1.5vw] text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {row?.ticket_no?.length > 12 ? (
              <Tooltip
                placement="top"
                title={row?.ticket_no}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                {`${row?.ticket_no?.slice(0, 12)}...`}
              </Tooltip>
            ) : (
              <div>{row.ticket_no}</div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          PNR Number
        </div>
      ),
      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="ml-[1.5vw] text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {row?.pnr_no?.length >= 10 ? (
              <Tooltip
                placement="top"
                title={row?.pnr_no}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                {`${row?.pnr_no?.slice(0, 10)}...`}
              </Tooltip>
            ) : (
              <div>{row.pnr_no}</div>
            )}
          </div>
        );
      },
    },
 
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Operator Name
        </div>
      ),
      width: "12vw",
      render: (row, rowdta, index) => {
        return (
          <div className="ml-[1.5vw] text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {row.operator_name.length > 15 ? (
              <Tooltip
                placement="top"
                title={row.operator_name}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <p>{`${row.operator_name.slice(0, 15)}...`}</p>
              </Tooltip>
            ) : (
              <p>{row.operator_name}</p>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Mobile
        </div>
      ),
      width: "7vw",
      render: (row, rowdta, index) => {
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw]">
            {row.mobile}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Email
        </div>
      ),
      width: "5vw",
      render: (row, rowdta, index) => {
        return (
          <div className="ml-[2vw] text-[#1F4B7F] text-[1vw] py-[0.5vw]">
            {row?.email?.length >= 30 ? (
              <Tooltip
                placement="top"
                title={row?.email}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                {`${row?.email?.slice(0, 30)}...`}
              </Tooltip>
            ) : (
              <div>{row.email}</div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold flex justify-evenly items-center"
          style={{ color: "white" }}
        >
          <Tooltip
            placement="top"
            title="Cancelling Date / Time"
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
            }}
          >
            Cancelling D / T
          </Tooltip>
          <button onClick={handleDateSort}>
            {sortOrderDate === "ascend" ? (
              <Tooltip
                placement="top"
                title="Ascending"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            ) : sortOrderDate === "descend" ? (
              <Tooltip
                placement="top"
                title="Descending"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedDown />
              </Tooltip>
            ) : sortOrderDate === null ? (
              <Tooltip
                placement="top"
                title="Unsorted"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowUnsorted />
              </Tooltip>
            ) : (
              <Tooltip
                placement="top"
                title="Ascending"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            )}
          </button>
        </div>
      ),
      key: "cancel_date_time",
      // sorter: (a, b) =>
      //   new Date(a.cancel_date_time.slice(0, 10)) -
      //   new Date(b.cancel_date_time.slice(0, 10)),
      // sortOrder:
      //   sortedInfo.columnKey === "cancel_date_time" && sortedInfo.order,
      width: "12vw",
      render: (row, rowdta, index) => {
        return (
          <div
            className={`ml-[1.5vw] text-[#1F4B7F] text-[1vw] py-[0.5vw] ${
              row.cancel_date_time === "Invalid date" ? "text-center" : ""
            }`}
          >
            {row.cancel_date_time === "Invalid date"
              ? "-"
              : `${formatDate(
                  row.cancel_date_time.split(",")[0].trim()
                )} (${row.cancel_date_time.split(",")[1].trim()})`}
            {console.log(row.cancel_date_time, "cancelling date")}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold flex justify-evenly items-center"
          style={{ color: "white" }}
        >
          <p>Refund</p>
          <button onClick={handleFareSort}>
            {sortOrderFare === "ascend" ? (
              <Tooltip
                placement="top"
                title="Ascending"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            ) : sortOrderFare === "descend" ? (
              <Tooltip
                placement="top"
                title="Descending"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedDown />
              </Tooltip>
            ) : sortOrderFare === null ? (
              <Tooltip
                placement="top"
                title="Unsorted"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowUnsorted />
              </Tooltip>
            ) : (
              <Tooltip
                placement="top"
                title="Ascending"
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            )}
          </button>
        </div>
      ),
      key: "total_fare",
      // sorter: (a, b) => a.total_fare - b.total_fare,
      // sortOrder: sortedInfo.columnKey === "total_fare" && sortedInfo.order,
      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="grid grid-cols-4 text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            <p className="col-span-3 ml-[2vw]">
              {row.refund_amt === null
                ? "-"
                : `₹ ${
                    row?.refund_amt % 1 === 0
                      ? row.refund_amt
                          .replace(/(\.\d*?[1-9])0+$/, "$1")
                          .replace(/\.0+$/, "")
                      : row.refund_amt
                  }`}
            </p>
            
          </div>
        );
      },
    },
       {
      title: (
        <div
          className="text-[1.2vw] flex justify-center font-bold"
          style={{ color: "white" }}
        >
          Payment Status
        </div>
      ),
      width: "10vw",
      render: (row, rowdta, index) => {
        return (
          <div className="grid grid-cols-3 space-x-4 text-[#1F4B7F] text-[1.5vw] ">
            <div className="col-span-2 ml-[1.5vw] ">
              {row.status_type === "null" ? (
              <p className="flex justify-center">-</p>
            ) : row.status_type === "Requested" ? (
             
              <button
              onClick={()=>{ 
                setIsModalOpen(true)
                setRefund((row.refund_amt))
                setMobile(row.mobile)
                setEmail(row.email)
                setPayId(row.payment_id)
                setTicketNo(row.ticket_no)
                setCurrentPage(1)
                
                console.log(row.cancel_date_time,"PaymentId")
            } }
              className="bg-[#FF9900] flex justify-center rounded-[0.5vw] text-[1vw]  font-extrabold shadow-md shadow-black text-white w-[5.5vw] py-[0.2vw] text-center">Requested</button>
             ): (
              <p className="flex justify-center">-</p>
            )}
            </div>

            <button
              onClick={(e) => {
                e.stopPropagation();
                
                
                 handleRowClick(row);
                 setDate2(row.cancel_date_time)
              }}
              className="col-span-1"
            >
              {row.key === expandedRowKey ? (
                <IoIosArrowDropupCircle
                  style={{ height: "1.3vw", width: "1.3vw",  }}
                />
              ) : (
                <IoIosArrowDropdownCircle
                  style={{ height: "1.3vw", width: "1.3vw" , }}
                />
              )}
            </button>
          </div>
        );
      },
    },
  ];
  const data =
    currentItems?.length > 0 &&
    currentItems?.map((item, index) => ({
      key: index + 1,
      s_no: 1,
      email: item.login_user_email,
      mobile: item.login_user_mobile,
      ticket_no: item.ticket_no,
      pnr_no: item.pnr_no,
      source_name: item.source_name,
      destination_name: item.destination_name,
      operator_name: item.operator_name,
      total_fare: item.total_fare,
      refund_amt: item.refund_amt,
      payment_id:item.payment_id,
      
      
      cancel_date_time: item.cancel_date_time,
      status_type:item.status_type,
     
       
      hidden_details: (
 
     
       

        <div className="grid grid-cols-6">
          <div className=" col-span-2 border-r-[0.1vw] border-[#1F487C] flex items-center justify-center">
            <div className="px-[2vw] pt-[0.5vw] text-[#1F487C] w-[35vw]">
              <div className="flex items-center justify-between">
                <p className="font-bold text-[1.25vw]">{item.source_name}</p>
                <img src={bus} alt="bus" className="w-[2.5vw]" />
                <p className="font-bold text-[1.25vw]">
                  {item.destination_name}
                </p>
              </div>
              <div className="bg-[#1F487C] h-[0.1vh] my-[0.5vw]" />
              <div className="flex justify-between">
                <div>
                  <div className="flex items-center gap-[0.25vw]">
                    <MdLocationOn />
                    <p className="font-bold text-[1vw]">
                      {item.pickup_point_name.length >= 15 ? (
                        <Tooltip
                          placement="right"
                          title={item.pickup_point_name}
                          className="cursor-pointer text-[#1F487C]"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <p>{`${item.pickup_point_name.slice(0, 15)}...`}</p>
                        </Tooltip>
                      ) : (
                        <p>{item.pickup_point_name}</p>
                      )}
                    </p>
                  </div>
                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <MdDateRange />
                    <p>
                      {item.depature_date === null
                        ? "-"
                        : `${formatDate(item.depature_date.slice(0, 10))}`}
                    </p>
                  </div>
                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <MdOutlineAccessTime />
                    <p>{formatTime(item.depature_time)}</p>
                  </div>
                  {/* <div className="flex justify-between"><p>GST</p><p>{item.source_id}</p></div> */}
                  {/* <div className="flex justify-between"><p>GST</p><p>{item.pickup_point_id}</p></div> */}
                </div>

                <div className="flex flex-col items-end">
                  <div className="flex items-center gap-[0.25vw]">
                    <p className="font-bold text-[1vw] text-right">
                      {item.droping_point_name ? (
                        item.droping_point_name.length >= 15 ? (
                          <Tooltip
                            placement="left"
                            title={item.droping_point_name}
                            className="cursor-pointer text-[#1F487C]"
                            color="white"
                            overlayInnerStyle={{
                              color: "#1F487C",
                            }}
                          >
                            <p>{`${item.droping_point_name.slice(
                              0,
                              15
                            )}...`}</p>
                          </Tooltip>
                        ) : (
                          <p>{item.droping_point_name}</p>
                        )
                      ) : (
                        "-"
                      )}
                    </p>
                    <MdLocationOn />
                  </div>

                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <p>
                      {item.arrival_date === null
                        ? "-"
                        : `${formatDate(item.arrival_date.slice(0, 10))}`}
                    </p>
                    <MdDateRange />
                  </div>
                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <p>{formatTime(item.arraival_time)}</p>
                    <MdOutlineAccessTime />
                  </div>
                  {/* <div className="flex"><p>GST</p><p>{item.destination_id}</p></div> */}
                  {/* <div className="flex"><p>GST</p><p>{item.droping_point_id}</p></div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-2 border-r-[0.1vw] border-[#1F487C] flex items-center justify-center">
            <div className="bg-[#1F487C] rounded-lg">
              <div className="grid grid-cols-4 border-b-[0.1vw] border-white py-[0.75vw] ">
                <span className="text-white font-semibold text-[1vw] w-full border-r-[0.1vw] text-center border-white">
                  Seat No
                </span>
                <span className="text-white font-semibold text-[1vw] w-full border-r-[0.1vw] text-center border-white px-[0.5vw]">
                  Passengers
                </span>
                <span className="text-white font-semibold text-[1vw] w-full border-r-[0.1vw] text-center border-white">
                  Age
                </span>
                <span className="text-white font-semibold text-[1vw] w-full text-center">
                  Gender
                </span>
              </div>
              <div className="grid grid-cols-4 gap-x-[1.5vw] justify-items-center py-[0.25vw]">
                <span className="text-white font-normal text-[1vw]">
                  {item.passenger_details.map((pass) => (
                    <p>{pass.seat}</p>
                  ))}
                </span>
                <span className="text-white font-normal text-[1vw]">
                  {item.passenger_details.map((pass) => (
                    <p>{pass.name}</p>
                  ))}
                </span>
                <span className="text-white font-normal text-[1vw]">
                  {item.passenger_details.map((pass) => (
                    <p>{pass.age}</p>
                  ))}
                </span>
                <span className="text-white font-normal text-[1vw]">
                  {item.passenger_details.map((pass) => (
                    <p>{pass.gender}</p>
                  ))}
                </span>
              </div>
            </div>
          </div>
          
{date3>=date1? (
  <div className="col-span-2 flex items-center justify-center py-[0.5vw] text-[0.9vw]">
            <div className="border-2 border-dotted border-zinc-800 rounded-[1vw] px-[0.7vw] py-[0.5vw] w-[20vw] ml-[4vw] ">
              <div className="flex justify-between text-[#1F487C]">
                <p className="font-bold">Base Fare:</p>
                <p className="font-bold">
                  {item.base_fare === null
                    ? "-"
                    : `₹ ${Number(item.base_fare)}`}
                </p>
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              <div className="flex justify-between text-[#1F487C] ">
                <p className="font-bold">Cancellation Percentage:</p>
                <p className="font-bold">
                  {item.refund_percent === null
                    ? "-"
                    : `${(100-(item.refund_percent))}%`}
                </p>
                {/* <p>- ₹ {item?.tbs_deal_amount.endsWith('0') ? item.tbs_deal_amount.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.tbs_deal_amount}</p> */}
              </div>
              <div className="flex justify-between text-red-700">
                <p className="font-bold">Cancellation fee:</p>
                <p className="font-bold">
                  {item.refund_amt === null
                    ? "-"
                    : `(-) ₹ ${((item.base_fare/100)*(100-(item.refund_percent)))}`}
                </p>
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              {/* `₹ ${Number(item.refund_amt).toFixed(2)}` */}
              <div className="flex justify-between text-red-700">
                <p className="font-bold">TBS Deal:</p>
                <p className="font-bold">
                  {item.tbs_deal === null
                    ? "-"
                    : ` (-) ₹ ${Number(item.tbs_deal)}`}
                </p>
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              {item.tbs_discount>0 ? <div className="flex justify-between text-red-700">
                <p className="font-bold">TBS Discount:</p>
                <p className="font-bold">
                {`(-) ₹ ${Number(item.tbs_discount).toFixed(2)}`}
                    
                </p>
                
              </div>:" "}
              <div className="flex justify-between text-red-700">
                <p className="font-bold">Platform Fee:</p>
                <p className="font-bold">
                  {
 `(-) ₹ ${((item.passenger_details.length)*15)}`}
                    
                </p>
                
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              <div className="flex justify-between border-t-[0.1vw] border-zinc-800 mt-[0.3vw]">
                <p className="font-bold">Total Refund:</p>
                <p className="font-bold">
                  {item.total_fare && item.refund_amt === null
                    ? "-"
                    : `₹ ${((item.base_fare/100)*item.refund_percent)-item.tbs_deal-((item.passenger_details.length)*15)-(Number(item.tbs_discount).toFixed(2))}`}
                </p>
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              {/* <div className="flex justify-between">
            <p>Status</p>
            <p>{item.payment_status}</p>
          </div> */}
            </div>
          </div>):( 
          <div className="col-span-2 flex items-center justify-center py-[0.5vw] text-[0.9vw]">
            <div className="border-2 border-dotted border-zinc-800 rounded-[1vw] px-[1vw] py-[0.5vw] w-[15vw]">
              <div className="flex justify-between text-[#1F487C]">
                <p className="font-bold">Total Fare</p>
                <p className="font-bold">
                  {item.total_fare === null
                    ? "-"
                    : `₹ ${Number(item.total_fare).toFixed(2)}`}
                </p>
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              <div className="flex justify-between text-[#1F487C] ">
                <p className="font-bold">Refund %</p>
                <p className="font-bold">
                  {item.refund_percent === null
                    ? "-"
                    : `${item.refund_percent}%`}
                </p>
                {/* <p>- ₹ {item?.tbs_deal_amount.endsWith('0') ? item.tbs_deal_amount.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.tbs_deal_amount}</p> */}
              </div>
              <div className="flex justify-between border-t-[0.1vw] border-zinc-800 ">
                <p className="font-bold">Refund Amount</p>
                <p className="font-bold">
                  {item.total_fare && item.refund_amt === null
                    ? "-"
                    : `₹ ${Number(item.refund_amt).toFixed(2)}`}
                </p>
                {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
              </div>
              
            </div>
          </div>)
    }
        </div>
              
      ),
    
    }));
    

 
  useEffect(() => {
    setSpinning(true);
    if(deviceid === 0){
      GetRefundRequestDetails(dispatch,setSpinning,deviceid)
    } else if (deviceid === 1) {
      console.log("BookingTable deviceId:", deviceid);
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    } else if (deviceid === 2) {
      console.log("BookingTable deviceId:", deviceid);
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    }
    dispatch({type:"RESETNUMBER"})
  },[deviceid]);

   useEffect(() => {
    handleGetUser(dispatch)
  }, []);

  
 
  
  
  return (
    <div>
      
      <div
        className={`h-[72.3vh] custom-table-container ${
          isRowExpanded ? "mb-[vh]" : ""
        } overflow-y-auto`}
      >
        
        {spinning ? (
          <div className="absolute top-[50vh] left-[50vw] flex justify-center items-center  z-10">
            <Spin size="large" />
          </div>
        ) : (
          <Table
            className="custom-table"
            columns={columns}
            dataSource={data}
            // onChange={handleChange}
            pagination={false}
            locale={{ emptyText: "No Data Available" }}
            expandable={{
              expandedRowRender: (record) => (
                <p style={{ margin: 0 }}>{record?.hidden_details}</p>
              ),
            }}
            // expandedRowRender={(record) => (
            //   <p style={{ margin: 0 }}>{record?.hidden_details}</p>
            // )}
            expandRowByClick={true}
            
            rowClassName={(row) =>
              row?.key === expandedRowKey ? "expanded-row" : ""
            }
            expandIcon={() => null}
            expandIconColumnIndex={-1}
            expandedRowKeys={expandedRowKey ? [expandedRowKey] : []}
          />
        )}
      </div>
      <div className={`${isRowExpanded ? "mb-[10vh]" : ""}`}>
        {getrefundrequest?.length > 10 && (
          <div className=" mt-[1vw]  flex justify-between items-center ">
            <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw] ">
              <span>Showing</span>
              <span className="font-bold">
                {currentItems && currentItems?.length > 0 ? (
                  <div>
                    {indexOfFirstItem + 1} -{" "}
                    {indexOfFirstItem + currentItems?.length}
                  </div>
                ) : (
                  "0"
                )}
              </span>
              <span>from</span>
              <span className="font-bold">
                {" "}
                {getrefundrequest?.length > 0
                  ? getrefundrequest?.length
                  : 0}
              </span>
              <span>data</span>
            </div>
            <div>
              <ReactPaginate
                activePage={activePage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={getrefundrequest?.length}
                pageRangeDisplayed={3}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
                prevPageText={
                  <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                }
                nextPageText={
                  <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                }
                firstPageText={
                  <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                }
                lastPageText={
                  <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                }
              />
            </div>
          </div>
        )}



        

        
        <div>
       

         <ModalPopup

        show={isModalOpen}
        onClose={closeModal}
        width="45vw"
        height="23vw"
        closeicon={false}
      >
        {currentpage===1&&
        <div>
         <div className="grid grid-cols-2 ">
            <p className=" col-span-1 text-[1.4vw] text-[#1F4B7F] flex justify-between font-bold ml-[1vw]" >PAYMENT REFUND</p>
           <div className="col-span-1 flex justify-between gap-x-4 ml-[2.3vw] mr-[1vw]">
             <button
                    type="button"
                    className="flex text-[#1F4B7F] text-[1vw] border-[0.1vw] w-[8vw] border-[#1F4B7F]  bg-white px-[2vw]  py-[0.5vw] rounded-[0.7vw] items-center justify-center"
                    style={{ transition: "all 0.3s" }}
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
            
                    <button
                      type="submit"
                      className="flex text-white text-[1vw] border-[0.1vw] w-[8vw] border-[#1F4B7F] bg-[#1F4B7F] px-[2vw]  py-[0.5vw] rounded-[0.7vw] items-center justify-center"
                    style={{ transition: "all 0.3s" }}
                     onClick={()=>{
                      if(currentpage===1){
                             setCurrentPage(2)
                            
                             
                      }
                      }}
                    >
                      Next
                    </button>
           </div>
                  
</div>  
          <Formik 
          initialValues={{mobile:mobile||"",
            email:email||"",
            amount:refund||"",
            payment_type:"Normal",
            message:"Bus Booking",
           pay_id:payId,
           ticket_no:ticketNo,
            
          }}
          
          
           onSubmit={(values) => handleSubmit(values)
            
           }
           
          >
            
             {({ values, handleSubmit,setFieldValue }) => (
              setValues(values),
              console.log(values,"value"),
              <Form>
               
         <div className="grid  mt-[2.6vw] gap-y-6 ">
          
         
       <div className="col-span-1 grid grid-cols-2 ">
           <div className=" col-span-1 relative justify-center  ml-[1vw] mr-[2vw]">
        <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                          Mobile:
        </label>
        <div>
          <Field
          as="input"
            type="text"
            name="mobile"
            id="mobile"
            disabled
            className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
            value={mobile}
            
            
        />
        
        </div>
       </div>
        <div className="col-span-1 relative justify-center   mr-[1vw] ml-[2vw]">
        <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                          Email:
        </label>
        <div>
          <Field
            as="input"
            type="text"
            name="email"
            id="email"
            disabled
            className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
            value={email}
            
        />
        </div>
       </div>
       </div>
     <div className="grid grid-cols-2 mt-[1vw]">
        <div className=" col-span-1 flex-col flex relative ml-[1vw] mr-[2vw]">
        <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                          Refund Amount:
        </label>
        <div>
          <Field
             as="input"
            type="text"
            name="amount"
            id="amount"
            disabled
            className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
            value={refund}
            
        />
        </div>
       </div>
       <div className="col-span-1 relative  justify-center  mr-[1vw] ml-[2vw]">
          <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
            Payment Type:
            {/* <span className="text-[1vw] text-red-600 pl-[0.25vw]">*</span> */}
          </label>
         
          <Field
            as="input"
            type="text"
            name="paymentType"
            id="paymentType"
            disabled
            className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
            value={values.payment_type}
            
        />

          
        </div>
     </div>
      {/* <div className=" grid grid-rows justify-start  mt-[1vw] ml-[1.2vw]">
          <p className="text-[0.9vw]  font-bold text-gray-600 ">Note :<span className="text-[0.8vw]  font-medium text-gray-500 ml-[0.5vw]">The amount will be credited back to your account in 5 to 7 days.</span></p>
          
          
          
        </div> */}
        
      
          <div className="col-span-1 grid grid-cols-1 ml-[1vw] mr-[1vw] mt-[0.6vw]">
            {/* <label className="text-[#1F4B7F] text-[1vw]  font-bold relative flex items-center">
                          Message:
        </label>
            <Field
            as="textarea"
            name="message"
            id="message" 
            style={{ resize: "none" }}
            placeholder="Please enter your Meassage"
            value={values.message}
            className="border-r-[0.25vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw]  border-[#1F487C] text-[#1F487C] text-[1vw]  h-[4.5vw] w-full rounded-[0.5vw] outline-none px-[0.6vw] pt-[0.5vw] placeholder:text-[1vw] placeholder:font-sans"
            />
<ErrorMessage
            name="message"
            component="div"
            className="text-red-500 text-[0.8vw] bottom-[-1.2vw]"
          /> */}
            
          </div>
 
   
   
         </div>
         
         </Form>
             )}

             
         </Formik>
         </div>
}

{currentpage===2&&

<div >
         


 <Formik 
 enableReinitialize={true}
          initialValues={{
            otp:otp||"",
            userNumber:userNumber||"",
            ticket_no:ticketNo||"",
            userName:selectedUser||"",
            
          }}
          
          // validationSchema={validationSchema}
           onSubmit={(values) => {handleOTPSubmit(values)
            console.log(values,"valueeeee")}
           }
           
          >
            
             {({ values, handleOTPSubmit,setFieldValue }) => (
              setVerifyValues(values),
              
              
              <Form>

                <div className="grid grid-cols-2" >
            <p className=" col-span-1 text-[1.4vw] text-[#1F4B7F] flex justify-between font-bold ml-[1vw]">PAYMENT REFUND</p>
             <div className="col-span-1 flex justify-between gap-x-6 mr-[1vw] ml-[2.3vw]">
                    <button
                      type="submit"
                      className="flex text-[#1F4B7F] text-[1vw] border-[0.1vw] w-[8vw] border-[#1F4B7F] bg-white px-[2vw] gap-[0.5vw] py-[0.5vw] rounded-[0.7vw] items-center justify-center"
                      //   onClick={() => setBgImage(true)}
                      onClick={handlePrevious
                    
                      }
                    >
                      Back
                    </button>
                    <button
                    type="button"
                    
                    className={ `cursor-not-allowed flex text-[#1F4B7F] text-[1vw] border-[0.1vw] w-[8vw]  px-[2.5vw] gap-[0.5vw] py-[0.5vw] rounded-[0.7vw] items-center justify-center"
                     ${values.otp ? 'cursor-pointer border-[#1F487C] border-[0.1vw]  text-white bg-[#1F487C] shadow-[#1F487C]' : 'cursor-not-allowed border-gray-500 border-[0.1vw]  text-white bg-gray-600 shadow-gray-500 '}
                      `}
                    style={{ transition: "all 0.3s" }}
                    onClick={()=>
                        handleSubmitCheck()
                      
                       
                    
                    }
                       disabled={!values.otp}
                    
                  >
                    Submit
                  </button>


                    </div>
                     {/* ${values.otp ? 'cursor-pointer border-[#1F487C] border-[0.1vw]  text-white bg-[#1F487C] shadow-[#1F487C]' : 'cursor-not-allowed border-gray-500 border-[0.1vw]  text-white bg-gray-600 shadow-gray-500 '} */}
                    
                  
</div>  
         <div className="grid mt-[2.6vw] gap-y-5">
          
         
       <div className="col-span-1 grid grid-cols-2 ">
           <div className=" col-span-1 relative justify-center  ml-[1vw] mr-[2vw]">
        <label
                    htmlFor="module_permissions"
                    className="text-[#1F4B7F] text-[1.1vw] font-semibold flex items-center"
                  >
                User:
                    
                    
                  </label>
        <div>
            <ConfigProvider
                       theme={{
                         components: {
                           Select: {
                             optionActiveBg: "#aebed1",
                             optionSelectedColor: "#FFF",
                             optionSelectedBg: "#e5e5e5",
                             optionHeight: "2",
                             
                           },
                         },
                       }}
                     >
                       <Select
                         showSearch
                         className="custom-select bg-white outline-none w-full mt-[0.2vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw] border-r-[0.25vw] border-b-[0.25vw] "
                         onMouseOver={handleMouseOver}
                         onChange={handleUserChange}
                         value={selectedUser}
                         
                         suffixIcon={
                           <span style={{ fontSize: "1vw", color: "#1f487c" }}>
                             <IoMdArrowDropdown size="2vw" />
                           </span>
                         }
                         placeholder={
                          <span style={{ fontSize: "1vw", color: "#9E9E9E" }}>Select User</span>
                         }
                     
                       >
                        {userDetail.map((user) => (
    <Option key={user.user_id} value={user.user_id}>
      {user.user_name}
    </Option>
  ))}
                        </Select>


                     </ConfigProvider>
                    
                     
        
        </div>
       </div>
        <div className="col-span-1 relative justify-center   mr-[1vw] ml-[2vw]">
        <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                          Mobile:
        </label>
        <div>
          <Field
            as="input"
            type="text"
            name="mobileNumber"
            id="mobileNumber"
            placeholder="Selected Mobile Number"
            className=" border-r-[0.25vw] w-full mt-[0.3vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.3vw] placeholder:font-sans"
            value={userNumber}
            
        />
        </div>
       </div>
       </div>
     <div className="grid grid-cols-2 mt-[1vw]">
        <div className=" col-span-1 flex-col flex relative ml-[1vw] mr-[2vw]">
        <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                          Enter OTP:
        </label>
                  <div className="relative w-full">
  <Field
    type="text"
    name="otp"
    id="otp"
    value={values.otp}
    placeholder="Enter 6-Digit OTP"
    onChange={handleChange}
    className="w-full pr-[8vw] border-r-[0.25vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] rounded-[0.5vw] outline-none px-[1.2vw] py-[1.3vw] placeholder:font-sans"
  />

  <button
    type="submit"
    className={`absolute top-[1.7vw] bottom-1/2 right-[0.1vw] -translate-y-1/2 h-[2.9vw] w-[6.5vw]  text-white font-semibold bg-[#1F487C]  hover:shadow-none shadow-[#1F487C] rounded-r-[0.4vw] text-[1vw]
      ${selectedUser ? 'cursor-pointer' : 'cursor-not-allowed'}
    `}
    style={{ transition: "all 0.3s" }}
    disabled={!selectedUser}
  >
    {isDisabled ? `${formatTimer(timeLeft)}` : (timeLeft === 0 ? 'Resend OTP' : 'Send OTP')}
  </button>
</div>


       </div>
     
     </div>
      

             
   
   
         </div>
         
      
            

                </Form>
             )}
                </Formik>


        


</div>

}
         
      </ModalPopup>
  


       
      </div>

      <div>
        <ModalPopup
          show={submitmodalIsOpen}
          onClose={closeSubmitModal}
          height="21vw"
          width="30vw"
          closeicon={false}
        >
          <div className="flex flex-col items-center mt-[0.5vw] gap-[2vw] justify-center">
             
            <div className="items-center flex-col flex justify-center ">
              <RiRefund2Line color="#1f4b7f" size={"5vw"} />
              <p className=" flex justify-center text-[1.7vw] font-semibold text-[#1f4b7f] mt-[0.7vw] ml-[1vw]">
            Are You Sure ?
          </p>
          <p className=" flex justify-center text-[1.1vw] text-[#1f4b7f] mt-[0.5vw]">Do you Want to Refund this Amount <span className="font-semibold text-[1.1vw] text-[#1f4b7f] ml-[0.5vw]">{refund}</span> ?</p>
            <div className=" h-[1vw] flex justify-center  mt-[0.9vw]">{isVerify}</div>
            </div>
          <div className="flex  gap-[2vw]  ">
            <button
            className="border-[#1f4b7f] border-[0.1vw] rounded-[0.5vw] text-[1.1vw] font-semibold text-[#1f4b7f] w-[10vw]  h-[3vw]"
            onClick={closeSubmitModal}
          >
            No
          </button>
          <button
          type="button"
            className={`cursor-not-allowed bg-[#1f4b7f] text-white font-semibold text-[1.1vw] w-[10vw] h-[3vw] rounded-[0.5vw]
              ${verifyStatus===true?'cursor-pointer':'cursor-not-allowed'}
              `}
            disabled={verifyStatus===false}
           
            onClick={() => { 
              handleSubmitClick()
              handleOTPVerify(verifyValues)
            }
              
            }
          >
            Yes
          </button>
          </div>
        </div>
        </ModalPopup>
      </div>

      
      
      </div>


      
     
    </div>
    
  );
  
}
